module.exports = __webpack_public_path__ + "static/media/gidro_os.4c72cc17.pdf";